import { Dispatch } from 'react';
import { request } from './request';
import { SessionAction } from '../interfaces/Session';

export function getDocumentSubThicket(dispatch: Dispatch<SessionAction>, id: string) {
  return request(dispatch, `/thicket/${id}/all`, {
    method: 'GET',
  });
}